<template>
  <app-modal
    :modal-id="modalId"
    :title="title"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
    modal-size="large"
    modal-alignment="top"
  >
    <template slot="header">
      <h5 class="modal-title">{{ title }}</h5>
      <button
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>

    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        ref="form"
        enctype="multipart/form-data"
        :data-url="
          selectedUrl
            ? `/evaluator/documentaryEvaluation/findingsDetected/${inputs.id}`
            : `/evaluator/documentaryEvaluation/findingsDetected`
        "
      >
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>Categoria</label>
              <app-input
                type="select"
                v-model="inputs.type"
                :list="type"
                :disabled="true"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label>Requisito</label>
              <app-input
                type="textarea"
                v-model="inputs.requirement"
                placeholder="Ingrese los requisitos"
                :disabled="true"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label>Hallazgo</label>
              <app-input
                type="textarea"
                v-model="inputs.finding"
                placeholder="Ingrese el hallazgo"
                :disabled="true"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label>Evidencia</label>
              <app-input
                type="textarea"
                v-model="inputs.evidence"
                placeholder="Ingrese la evidencia"
                :disabled="true"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>Reiterada Tras Última Evaluación</label>
              <app-input
                type="radio-buttons"
                v-model="inputs.repeated_after_last_evaluation"
                :list="confirm"
                :disabled="true"
              />
            </div>
          </div>
        </div>

        <div class="row" v-if="inputs.repeated_after_last_evaluation">
          <div class="col-12">
            <div class="form-group">
              <label>Espefique el Hallazgo</label>
              <app-input
                type="textarea"
                v-model="inputs.specify_finding"
                placeholder="Ingrese el hallazgo"
                :disabled="true"
              />
            </div>
          </div>
        </div>

        <div class="row" v-if="inputs.finding_1">
          <div class="col-12">
            <div class="form-group">
              <label>Adjunto (Opcional)</label>
              <button
                type="submit"
                class="btn btn-success"
                @click.prevent="openTab('finding_1')"
              >
                <app-icon name="file" />
                {{ $t("view") }}
              </button>
            </div>
          </div>
        </div>

        <legend class="row col-12 col-form-label text-primary pt-0 mt-3 mb-3">
          <h5>Respuesta</h5>
        </legend>

        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>Evidencia Satisfactiria</label>
              <app-input
                type="radio-buttons"
                v-model="inputs.is_satisfactory"
                :list="confirm"
                :disabled="true"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label>Acciones Correctivas</label>
              <app-input
                type="textarea"
                v-model="inputs.corrective_actions_1"
                placeholder="Ingrese la evidencia"
                :disabled="true"
              />
            </div>
          </div>
        </div>

        <div class="row" v-if="inputs.finding_2">
          <div class="col-12">
            <div class="form-group">
              <label>Adjunto</label>
              <div>
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab('finding_1')"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label>Comentario del Evaluador</label>
              <app-input
                type="textarea"
                v-model="inputs.comment_1"
                placeholder="Ingrese los comentarios"
                :disabled="true"
              />
            </div>
          </div>
        </div>

        <legend class="row col-12 col-form-label text-primary pt-0 mt-3 mb-3">
          <h5>Registro de Hallazgo</h5>
        </legend>

        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label>Observaciones</label>
              <app-input
                type="textarea"
                v-model="inputs.observations"
                placeholder="Ingrese las observaciones"
                :required="true"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>Cierre Satisfactorio</label>
              <app-input
                type="radio-buttons"
                v-model="inputs.satisfactory_closure"
                :list="confirm"
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>Evidencia Adicional</label>
              <app-input
                type="radio-buttons"
                v-model="inputs.additional_evidence"
                :list="confirm"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>Seguimiento</label>
              <app-input
                type="radio-buttons"
                v-model="inputs.tracing"
                :list="confirm"
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>Amonestación</label>
              <app-input
                type="radio-buttons"
                v-model="inputs.admonition"
                :list="confirm"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>Plazo</label>
              <app-input
                type="text"
                v-model="inputs.term"
                placeholder="Ingrese el plazo"
                :required="true"
              />
            </div>
          </div>
        </div>
      </form>
    </template>

    <template slot="footer">
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        Cerrar
      </button>
      <button type="submit" class="btn btn-primary" @click.prevent="submit">
        Guardar
      </button>
    </template>
  </app-modal>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";

export default {
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
    modalTitle: String,
    editModalTitle: String,
  },
  data() {
    return {
      preloader: false,
      inputs: {
        observations: null,
        satisfactory_closure: 0,
        additional_evidence: 0,
        tracing: 0,
        admonition: 0,
        term: null,
      },
      modalId: "modal-add-edit",
      type: [
        { id: null, value: this.$t("select_option") },
        {
          id: "NC",
          value: "No Conformidad",
        },
        {
          id: "C",
          value: "Comentario",
        },
      ],
      confirm: [
        {
          id: 1,
          value: "SI",
        },
        {
          id: 0,
          value: "NO",
        },
      ],
    };
  },
  computed: {
    title() {
      return this.selectedUrl ? this.editModalTitle : this.modalTitle;
    },
  },
  created() {
    if (this.selectedUrl) {
      this.preloader = true;
    } else {
      this.inputs.requirement = this.$store.state.evaluatorReview.evalTest.accreditation_applications.accreditation_activity.rule_name;
    }
  },
  methods: {
    submit() {
      this.save(this.inputs);
    },

    afterSuccess(response) {
      // this.$toastr.s(response.data.message);
      this.$toastr.s(this.$t("updated_success"));
      this.$hub.$emit("reload-" + this.tableId);
    },

    afterSuccessFromGetEditData(response) {
      this.inputs = response.data;
      this.preloader = false;
    },

    openTab(fileName) {
      const w = window.open(this.inputs[fileName].path, "_blank");
      w.focus();
    },
  },
};
</script>
